import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCompanies } from '../api/companies.js';
import CompaniesPanel from '../components/panels/CompaniesPanel.jsx';
import MessagesPanel from '../components/panels/MessagesPanel.jsx';

export default function MessagesPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { companyId } = useParams();

    const { data: companies } = useCompanies();
    const companyName = companies?.find((c) => c.id === companyId)?.name;

    function selectCompany(id) {
        navigate(id ? `/messages/${encodeURIComponent(id)}` : '/messages');
    }

    return (
        <div className="workspace">
            <CompaniesPanel
                readOnly
                allOption={t('messages.allCompanies')}
                selectedCompanyId={companyId}
                onSelect={selectCompany}
            />
            <MessagesPanel key={companyId ?? 'all'} companyId={companyId} companyName={companyName} />
        </div>
    );
}